/**
 * F2. Собеседование: 3 реплики работодателя, на каждую 3 ответа
 * (честный/уверенный/скромный); уровень места написан, подсказка-подсветка
 * — пометкой у ответа, когда знания и отношения её дают.
 */
import { t } from '@life/i18n';
import type { InterviewAnswer, InterviewInput, InterviewState } from '@life/minigames';
import { useState } from 'preact/hooks';
import type { MinigameScreenProps } from './types';
import { Choice } from './ui/Choice';

export function Interview({ state, onInput }: MinigameScreenProps<InterviewInput, InterviewState>) {
  const [picks, setPicks] = useState<(number | null)[]>(() => state.lines.map(() => null));
  const complete = picks.every((p) => p !== null);

  return (
    <>
      <p class="hint">
        {state.kind === 'work.change' && state.currentLevel !== null
          ? t('ui.minigame.interview.change', { level: state.level, current: state.currentLevel })
          : t('ui.minigame.interview.rules', { level: state.level })}
      </p>
      {state.lines.map((line, i) => (
        <div class="q" key={line.key} data-question={i}>
          <p class="q-text">{t(line.key)}</p>
          <Choice
            label={t(line.key)}
            items={line.answers.map((key, j) => ({ text: t(key), ...(line.hint === j ? { note: t('ui.minigame.hint') } : {}) }))}
            value={picks[i] ?? null}
            onChange={(j) => setPicks(picks.map((p, k) => (k === i ? j : p)))}
          />
        </div>
      ))}
      <button
        type="button"
        class="btn accent block"
        disabled={!complete}
        onClick={() => onInput({ picks: picks.map((p) => (p ?? 0) as InterviewAnswer) })}
      >
        {t('ui.minigame.interview.submit')}
      </button>
    </>
  );
}
